import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const ADMIN_PASSWORD = 'Miles@24';
const AUTH_KEY = 'mmp_admin_auth';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem(AUTH_KEY, 'true');
      navigate('/admin/dashboard');
    } else {
      setError('Incorrect password');
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-emerald-100 flex items-center justify-center px-4">
      <div
        className={`bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md ${
          shake ? 'animate-shake' : ''
        }`}
      >
        <div className="flex flex-col items-center mb-8">
          <img
            src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/e62ab94b377030bab304226dbded8c13.jpeg"
            alt="The Monthly Millionaire Project"
            className="h-16 w-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-gray-900 text-center">
            Admin Dashboard
          </h1>
          <p className="text-sm text-gray-600 mt-2 text-center">
            Enter your password to access the dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-base"
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i
                  className={`ri-${showPassword ? 'eye-off' : 'eye'}-line text-xl`}
                ></i>
              </button>
            </div>
            {error && (
              <p className="text-red-600 text-sm mt-2 flex items-center gap-1">
                <i className="ri-error-warning-line"></i>
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            className="w-full bg-emerald-600 text-white py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Access Dashboard
          </button>
        </form>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-8px); }
          20%, 40%, 60%, 80% { transform: translateX(8px); }
        }
        .animate-shake {
          animation: shake 0.5s;
        }
      `}</style>
    </div>
  );
}